import { render, staticRenderFns } from "./teacherView.vue?vue&type=template&id=40f04b7f&scoped=true"
import script from "./teacherView.vue?vue&type=script&lang=js"
export * from "./teacherView.vue?vue&type=script&lang=js"
import style0 from "./teacherView.vue?vue&type=style&index=0&id=40f04b7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f04b7f",
  null
  
)

export default component.exports